<template>
    <div class="shadow-container" :style="el?.getShadowStyle('boxShadow')">
    </div>
</template>

<script>
import BasePreviewComponents from "./base/basePreviewComponents.vue";
export default {
    name: 'ShadowMedia',
    extends: BasePreviewComponents,
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>
.shadow-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>